module.exports = __webpack_public_path__ + "img/logo-fundanow-w.a644919f.svg";